import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class CreditReportTableFee extends Component<{ fee: string }> {
    render() {
        return <OptionalTableCell title='Credit Report Fee'>
            {this.props.fee}
        </OptionalTableCell>;
    }
}
